import type { ReactNode } from 'react'

import { EdgeLabelPopover } from './edge-label-popover.molecule'

interface EdgePopoverState {
  isOpen: boolean
  edgeId: string | null
  label: string
  position: { x: number; y: number }
}

export interface AgencyFlowEdgePopoverProps {
  state: EdgePopoverState
  onOpenChange: (isOpen: boolean) => void
  onSave: (label: string) => void
}

export const AgencyFlowEdgePopover = ({
  state,
  onOpenChange,
  onSave,
}: AgencyFlowEdgePopoverProps): ReactNode => {
  if (!state.isOpen) return null

  return (
    <EdgeLabelPopover
      isOpen={state.isOpen}
      onOpenChange={onOpenChange}
      label={state.label}
      onSave={onSave}
      triggerElement={
        <div
          className="fixed"
          style={{
            left: state.position.x,
            top: state.position.y,
            width: 1,
            height: 1,
          }}
        />
      }
    />
  )
}

AgencyFlowEdgePopover.displayName = 'AgencyFlowEdgePopover'
